// 都道府県のマッピング
const prefectureMap = {
  '北海道': ['北海道'],
  '東北': ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県'],
  '関東': ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県'],
  '中部': ['新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県'],
  '近畿': ['三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県'],
  '中国': ['鳥取県', '島根県', '岡山県', '広島県', '山口県'],
  '四国': ['徳島県', '香川県', '愛媛県', '高知県'],
  '九州・沖縄': ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
};

function initShopList(sectionId) {
  const regionFilter = document.getElementById(`region-filter-${sectionId}`);
  const prefectureFilter = document.getElementById(`prefecture-filter-${sectionId}`);
  const shopSearch = document.getElementById(`shop-search-${sectionId}`);
  const shopGrid = document.getElementById(`shop-list-grid-${sectionId}`);
  const resultsCount = document.getElementById(`results-count-${sectionId}`);
  const totalCount = document.getElementById(`total-count-${sectionId}`);
  const emptyMessage = document.getElementById(`shop-list-empty-${sectionId}`);
  
  if (!shopGrid) return;

  // 初期状態で全店舗数を表示
  const allShops = shopGrid.querySelectorAll('.shop-card');
  totalCount.textContent = allShops.length;

  // 都道府県フィルターの更新
  function updatePrefectureFilter(selectedRegion) {
    prefectureFilter.innerHTML = '<option value="">都道府県を選択</option>';
    
    if (selectedRegion && prefectureMap[selectedRegion]) {
      const prefectures = prefectureMap[selectedRegion];
      prefectures.forEach(pref => {
        const option = document.createElement('option');
        option.value = pref;
        option.textContent = pref;
        prefectureFilter.appendChild(option);
      });
    } else {
      // 全地域の都道府県を追加
      Object.values(prefectureMap).flat().forEach(pref => {
        const option = document.createElement('option');
        option.value = pref;
        option.textContent = pref;
        prefectureFilter.appendChild(option);
      });
    }
  }

  // フィルタリング処理
  function filterShops() {
    const selectedRegion = regionFilter.value;
    const selectedPrefecture = prefectureFilter.value;
    const searchTerm = shopSearch.value.toLowerCase().trim();

    let visibleCount = 0;

    allShops.forEach(shop => {
      const shopRegion = shop.getAttribute('data-region');
      const shopPrefecture = shop.getAttribute('data-prefecture');
      const shopName = shop.getAttribute('data-shop-name');

      let isVisible = true;

      // 地域フィルター
      if (selectedRegion && shopRegion !== selectedRegion) {
        isVisible = false;
      }

      // 都道府県フィルター
      if (selectedPrefecture && shopPrefecture !== selectedPrefecture) {
        isVisible = false;
      }

      // 検索フィルター
      if (searchTerm && !shopName.includes(searchTerm)) {
        isVisible = false;
      }

      if (isVisible) {
        shop.classList.remove('hidden');
        visibleCount++;
      } else {
        shop.classList.add('hidden');
      }
    });

    // 結果数の更新
    totalCount.textContent = visibleCount;

    // 空メッセージの表示/非表示
    if (visibleCount === 0) {
      emptyMessage.style.display = 'block';
      shopGrid.style.display = 'none';
    } else {
      emptyMessage.style.display = 'none';
      shopGrid.style.display = 'grid';
    }
  }

  // イベントリスナーの設定
  regionFilter.addEventListener('change', function() {
    const selectedRegion = this.value;
    updatePrefectureFilter(selectedRegion);
    prefectureFilter.value = ''; // 都道府県フィルターをリセット
    filterShops();
  });

  prefectureFilter.addEventListener('change', filterShops);

  shopSearch.addEventListener('input', filterShops);

  // 初期化：全都道府県を表示
  updatePrefectureFilter('');
  
  // 初期フィルタリング
  filterShops();
}

// グローバルスコープに公開
window.initShopList = initShopList;

